import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/authContext'
import UserMenu from '../partials/user-menu'

const Header = () => {
    const navigate = useNavigate()
    const { userLoggedIn } = useAuth()
    return (
        <nav className='flex flex-row gap-x-2 w-full z-20 fixed top-0 left-0 h-12 border-b place-content-left items-center App-top-nav'>
            {
                userLoggedIn
                    ?
                    <>
						<div class="flex justify-between w-full">
							<div>
								<img src="/ControlRoomLogo.png" alt="Control Room" width="125px"/>
							</div>
							{/* <button onClick={() => { navigate('/workspace') }} className='nav-button text-sm'>Workspace</button>
							<button onClick={() => { doSignOut().then(() => { navigate('/login') }) }} className='nav-button text-sm'>Logout</button> */}
							<div>
								<UserMenu />
							</div>
						</div>						
                    </>
                    :
                    <>
						<img src="/ControlRoomLogo.png" alt="Control Room" width="125px"/>
                        {/* <Link className='text-sm nav-button' to={'/login'}>Login</Link>
                        <Link className='text-sm nav-button' to={'/register'}>Register New Account</Link> */}
                    </>
            }

        </nav>
    )
}

export default Header